import { ColDef } from 'ag-grid-community';
import { renderNA, importErrorFunction, generateImportColumn, importTextFormatEditor, formatEditor } from './../../../../../utils/commonFunctions';

/**
 * Column definitions for listing page
 * cellRenderer to show data as a string
 * valueGetter for getting data from export functionality of ag-grid
 * filterValueGetter for getting data from filter
 * tooltipValueGetter for getting data from tooltip
 * textFormatEditor for getting data from text editor
 */
// nameColumn,
const columnDefs: ColDef[] = [
    {
      ...generateImportColumn("First Name", "first_name"),
      ...importErrorFunction(), // for display error message in ag-grid in case of error
      cellRenderer: (props: any) => {
        return renderNA(props.data.first_name);
      },
    },
    {
      ...generateImportColumn("Last Name", "lastname"),
      ...importErrorFunction(),
      cellRenderer: (props: any) => {
        return renderNA(props.data.lastname);
      },
      filterValueGetter: (props: any) => {
        return props.data?.[`lastname`]?.toString();
      },
    },
    {
      ...generateImportColumn("Mobile Number", "mobile_number"),
      ...importErrorFunction(),
      cellRenderer: (props: any) => {
        return renderNA(props.data.mobile_number);
      },
      filterValueGetter: (props: any) => {
        return props.data?.[`mobile`]?.toString();
      },
    },
    {
      ...generateImportColumn("Email", "email"),
      ...importErrorFunction(),
      cellRenderer: (props: any) => {
        return renderNA(props.data.email);
      },
      filterValueGetter: (props: any) => {
        return props.data?.[`email`]?.toString();
      },
    },
    // {
    //   ...generateImportColumn("Status", "status"),
    //   ...importErrorFunction(),
    //   cellRenderer: (props: any) => {
    //     return renderNA(props.data.status);
    //   },
    // },
    // {
    //   ...generateImportColumn("Reason", "message"),
    //   ...importErrorFunction(),
    //   cellRenderer: (props: any) => {
    //     return renderNA(props.data.message);
    //   },
    // },
  ];
export default columnDefs;
